export { PLUGIN_KEY, PLUGIN_PRIORITY, ManualRowMove } from "./manualRowMove.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualRowMove/index.mjs
// module id = 1468
// module chunks = 1